module.exports = __webpack_public_path__ + "img/imagen5.74423bf8.png";